import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import lsUtil from 'APP_ROOT/components/common/lsUtil';
import Globals from '../globals';
import { strings, getCurrentLocale, setUserLocale } from '../../../localization';
import AccountDropdown from './AccountDropdown'
import HelpDropdown from './HelpDropdown';
import StatsDropdown from './StatsDropdown'

import { ModalContainer } from 'APP_ROOT/components/common/Modal2';
import Language from 'APP_ROOT/components/pages/account/Settings/Language';

export default class Header extends PureComponent {

    static propTypes = {
        features: PropTypes.object.isRequired,
        user: PropTypes.object,
        ravens: PropTypes.array,
        accountDetails: PropTypes.object
    }

    constructor(props) {

        super(props)

        this.state = {
            modalContainer: null
        };
    }

    onClickLanguage = () => {

        const dismissModal = () => {
            this.setState({modalContainer: null});
        }

        this.setState({
            modalContainer: (
                <ModalContainer title={strings.settings_language_header} smallDialogMode={true} onClickClose={dismissModal}>
                    <div className="account-page">{/* adding these div wrappers to leverage pre-existing CSS */}
                        <div className="settings-section no-border">
                            <Language stage={this.props.user.stage} hideHeader={true} onSuccess={dismissModal}/>
                        </div>
                    </div>
                </ModalContainer>
            )
        })
    }

    onClickLanguageWithoutUser = () => {

        const dismissModalContainer = () => {
            this.setState({modalContainer: null});
        }

        this.setState({
            modalContainer: (
                <ModalContainer
                    title={strings.settings_language_header}
                    smallDialogMode={true}
                    onClickClose={dismissModalContainer}
                >
                    <div className="message">
                        {strings.settings_language_description}
                    </div>
                    <div className="actions">
                        <button onClick={() => {
                            setUserLocale("en");
                            dismissModalContainer();
                        }} >
                            {strings.locale_name_en_ca}
                        </button>
                        <button onClick={() => {
                            setUserLocale("fr");
                            dismissModalContainer();
                        }} >
                            {strings.locale_name_fr_ca}
                        </button>
                    </div>
                </ModalContainer>
            )
        })
    }

    render() {

        var pageTitle = "";
        if (window.location.pathname.indexOf("/trip/") > -1) pageTitle = strings.formatString(strings.trip_sharing);

        const filenamePrefix = this.props.features.logo_url;
        const channelBrandingBaseUrl = this.props.features.channel_branding_base_url;
        const base = channelBrandingBaseUrl ? `${channelBrandingBaseUrl}/images` : '/images';
        var logoUrl = `${base}/${filenamePrefix}-white-${getCurrentLocale()}.png`;

        if (this.props.user && this.props.user.email && this.props.ravens) {
            return (
                <>
                {this.renderWithNavigation(logoUrl, pageTitle, this.props.user)}
                {this.state.modalContainer}
                </>
            );
        } else {
            return (
                <>
                {this.renderWithoutNavigation(logoUrl, pageTitle)}
                {this.state.modalContainer}
                </>
            );
        }
    }

    renderWithNavigation(logoUrl, pageTitle, user) {

        const { accountDetails } = this.props;
        var helpMenuItem = null;
        if (accountDetails && accountDetails.accountType === "FLEET") {
            helpMenuItem = <HelpDropdown {...this.props} user={user} />
        }

        const currentLocale = getCurrentLocale();

        return (
            <header id="mainHeader">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-4 col-lg-5 order-1 raven-logo">
                            <NavLink to={'/' + currentLocale + '/dashboard'} activeClassName="active">
                                <img src={logoUrl} alt="raven logo white" />
                            </NavLink>
                            <h1>{pageTitle}</h1>
                        </div>
                        <div className="header-navigation col-12 col-sm-8 col-lg-7 order-3 order-sm-2">
                            <div className="header-links">
                                <NavLink to={'/' + currentLocale + '/dashboard'} activeClassName="active">{strings.formatString(strings.dashboard)}</NavLink>
                                {
                                    this.props.features.show_history &&
                                        <NavLink to={'/' + currentLocale + '/stats/history'} activeClassName="active">{strings.history}</NavLink>
                                }
                                {
                                    this.props.features.fleet_reports &&
                                        <NavLink to={'/' + currentLocale + '/stats/reports'} activeClassName="active">{strings.formatString(strings.reports)}</NavLink>
                                }
                                {/*<StatsDropdown {...this.props} />*/}
                                <NavLink to={'/' + currentLocale + '/settings'} activeClassName="active">{strings.formatString(strings.settings)}</NavLink>
                                <AccountDropdown {...this.props} user={user} />
                                {this.props.features && this.props.features.language_selection ?
                                    <button className="btn-icon-circle-filled" onClick={this.onClickLanguage} >{currentLocale.substring(0,2).toUpperCase()}</button>
                                :
                                    null
                                }
                                {helpMenuItem}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    renderWithoutNavigation(logoUrl, pageTitle) {

        return (
            <header id="mainHeader">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-4 col-lg-5 order-1 raven-logo">
                            <NavLink to={'/' + getCurrentLocale() + '/'} activeClassName="active">
                                <img src={logoUrl} alt="raven logo white" />
                            </NavLink>
                            <h1>{pageTitle}</h1>
                        </div>
                        <div className="header-navigation col-12 col-sm-8 col-lg-7 order-3 order-sm-2">
                            <div className="header-links">
                                {this.props.features && this.props.features.language_selection ?
                                    <button className="btn-icon-circle-filled" onClick={this.onClickLanguageWithoutUser} >{getCurrentLocale().substring(0,2).toUpperCase()}</button>
                                :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
